var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list && _vm.list.length > 0
    ? _c("section", { staticClass: "video-model" }, [
        _c("h3", [_vm._v("电影")]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "video-model-list three" },
          _vm._l(_vm.list, function (item, index) {
            return _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show(index),
                    expression: "show(index)",
                  },
                ],
                key: index,
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: item.playurl,
                      uigs: "out_home_list_top_pic_movie",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "video-model-img-v" },
                      [
                        _c("img-item", {
                          attrs: { src: item.picurl, lazy: !_vm.show(index) },
                        }),
                        _vm._v(" "),
                        item.fee === "1"
                          ? _c("span", { staticClass: "tag-fee" }, [
                              _vm._v("VIP"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "tag-mark" }, [
                          _vm._v(
                            _vm._s(
                              item.score && item.score.length === 1
                                ? item.score + ".0"
                                : item.score
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "video-model-title" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                  ]
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "video-model-btn" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { uigs: "home_film_list_change" },
              on: { click: _vm.change },
            },
            [_c("span", { staticClass: "change" }, [_vm._v("换一换")])]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "/list?listTab=film",
          uigs: "out_home_list_bottom_film",
        },
      },
      [_c("span", { staticClass: "more" }, [_vm._v("查看更多")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }